import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
// necessary for 'Typewriter'
import 'proxy-polyfill/proxy.min.js';
import config from './config.json';
// Initialize window.services before loading any remotes
window.services = {};

const allowedHosts = ['guildacceptance.com', 'guild.com', 'guildeducation.com'];

const isAcceptance = (() => {
  const baseUrl = process.env.REACT_APP_GUILD_BASE_URL || '';

  if (baseUrl === 'guildacceptance.com') {
    return true;
  }

  try {
    const urlString = baseUrl.includes('://') ? baseUrl : `https://${baseUrl}`;
    const url = new URL(urlString);
    return allowedHosts.includes(url.host);
  } catch {
    return false;
  }
})();

config.services.forEach(({ subdomain }) => {
  const hostIsLocal = process.env.NODE_ENV === 'development';

  const envSubdomain = isAcceptance
    ? hostIsLocal
      ? `${subdomain}-dev`
      : `${subdomain}-staging`
    : subdomain;
  const NAME = snakeCase(subdomain).toUpperCase().replace(/\./, '_');
  const envKey = `REACT_APP_${NAME}_URL`;
  const defaultUrl = `https://${envSubdomain}.${process.env.REACT_APP_GUILD_BASE_URL}`;

  window.services[camelCase(subdomain)] = process.env[envKey] || defaultUrl;
});

// Load the app after services are initialized
import(/* webpackChunkName: "host" */ './index');
